import { WatchIcon } from '@/atoms/Icons/WatchIcon'
import { useExperimentContext } from '@/experimentation'
import { AudienceInterest, AudienceInterestText } from '@/organisms/AudienceInterest'
import { useSafeTrack } from '@/utils/analytics/safe-analytics'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'
import { useTranslate } from '@/utils/translate/translate-client'

export const AudienceInterestPreviewCTA = () => {
  const { t } = useTranslate('guild-voting')
  const { getFeatureValue } = useExperimentContext()
  const audienceInterestExperiment = getFeatureValue('audience_interest', false)
  const audienceInterestTextExperiment = getFeatureValue('audience_interest_alternate_banner_text', false)
  const router = useSafeRouter()
  const track = useSafeTrack()

  const onButtonClick = () => {
    track('Audience Interest Watch Preview Clicked')
    router.push('/audience-interest')
  }

  if (!audienceInterestExperiment) return null

  return (
    <AudienceInterest buttonText={t('previewNow', 'Preview Now')} onButtonClick={onButtonClick}>
      <WatchIcon color="warm-03" size={40} />
      {audienceInterestTextExperiment ? (
        <AudienceInterestText
          title={t('previewASurpriseMovie', 'Preview a Surprise Movie!')}
          description={t('seeTheFirst10MinuteFree', 'See the First 10 Minutes Free')}
        />
      ) : (
        <AudienceInterestText
          title={t('weAreEvaluatingANewMovie', 'We Are Evaluating a New Movie')}
          description={t('previewTheFirst10Minutes', 'Preview the First 10 Minutes')}
        />
      )}
    </AudienceInterest>
  )
}
